import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type LoadingRegionProps = {
  /** When true, sets `aria-busy` and renders screen-reader status text. */
  busy: boolean;
  /** i18n key passed to `t()` for the `sr-only` label (e.g. `common.loadingContent`). */
  labelKey: string;
  children: ReactNode;
  className?: string;
};

/**
 * Wraps skeleton (or other) content while loading. Announces status to assistive tech.
 */
export function LoadingRegion({ busy, labelKey, children, className }: LoadingRegionProps) {
  const { t } = useTranslation();
  return (
    <div className={cn(className)} aria-busy={busy}>
      {busy ? <span className="sr-only">{t(labelKey)}</span> : null}
      {children}
    </div>
  );
}
